import { lazy } from 'react';
import { authRoles } from 'app/auth';

const ShippingLabel = lazy(() => import('./order/Dialogs/ShippingLabelContent'))
const ShipmentProductImageHandler = lazy(() => import('../backoffice/shipment/ProductImages/ShipmentProductImageHandler'))
const DrawingRequest = lazy(() => import('./order/Drawing/DrawingRequest'))
const Orders = lazy(() => import('./orders/Orders'));
// Lazy like every element here, so importing this config does not pull in the store.
const SupplierListGate = lazy(() => import('app/main/apps/supplier/list/SupplierListGate'));
const Order = lazy(() => import('./order/Order'));
const ContainerManagement = lazy(() => import('../backoffice/containermanagements/ContainerManagement'));
const ScanToLoad = lazy(() => import('app/main/apps/scanToLoad/ScanToLoad'));

const SupplierAppConfig = {
  settings: {
    layout: {},
  },
  auth: authRoles.supplier,
  routes: [
    {
      path: 'in-production',
      // A supplier login gets the redesigned supplier list; admin / staff / sales keep Orders.
      element: <SupplierListGate type="in-production" for="in-production" module="in_productions"
        fallback={<Orders type="in-production" for="in-production" module="in_productions" />} />,
    },
    {
      path: 'fulfilled',
      element: <SupplierListGate type="fulfilled" for="fulfilled" module="shipped_orders"
        fallback={<Orders type="fulfilled" for="fulfilled" module="shipped_orders" />} />,
    },
    {
      path: 'confirmed',
      element: <SupplierListGate type="confirmed" for="confirmed" module="confirmed_orders"
        fallback={<Orders type="confirmed" for="confirmed" module="confirmed_orders" />} />,
    },
    // PGSS-5411: the fulfilled list had no detail route, so the Send Message action --
    // href /{stage}/{orderId}?type=view&tab=6 -- fell through to the 404 catch-all.
    // 'confirmed/:orderId' already existed, which is why only this stage was broken.
    //
    // 'in-production' has no detail route either. Whether it needs one depends on which
    // row actions are configured for that stage in workflow_actions, which is per-
    // environment data and not visible from this repo. Not added on speculation.
    {
      path: 'fulfilled/:orderId',
      element: <Order type="order" module="orders" />,
    },
    {
      path: '/shipments/shippingLabel/:orderId',
      element: <ShippingLabel />
    },
    // PGSS-5748 part 3: scan a supplier container's boxes as they are loaded. Same roles as the API
    // (supplier, staff, admin, sales); reached from the shipping labels page.
    {
      path: '/shipments/scan-to-load/:shipmentId',
      element: <ScanToLoad />,
    },
    {
      path: '/shipments/printProduction/:orderId',
      element: <ShippingLabel />
    },
    {
      path: '/shipments/uploadProductImages/:shipmentId',
      element: <ShipmentProductImageHandler type="upload" />
    },
    {
      path: 'drawing/:orderId/:type',
      element: <DrawingRequest />,
    },
    // new route for loading and unlaoding of orders for shipment
    {
      path: '/container-management/load/:shipmentId',
      element: <ContainerManagement type="load"/>,
    },
     {
      path: '/container-management/unload/:shipmentId',
      element: <ContainerManagement type="unload"/>,
    },
  ],
};

export default SupplierAppConfig;
